// import "./css/App.css";
// import LeftPortion from "./js/leftPortion/leftPortion";
// import RightPortion from "./js/rightPortion/rightPortion";
// import React, { useEffect } from "react";
// import PdfConnector from "./js/middlePortion/pdfConnector";

// import data from "./js/resources/data.json";
// const path = "../js/resources/data.pdf";

// const names = [
//   "Oliver Hansen",
//   "Van Henry",
//   "April Tucker",
//   "Ralph Hubbard",
//   "Omar Alexander",
//   "Carlos Abbott",
//   "Miriam Wagner",
//   "Bradley Wilkerson",
//   "Virginia Andrews",
//   "Kelly Snyder",
// ];

// function App() {
//   return (
//     <div className="flex flex-row">
//       <LeftPortion style={{ flex: "0 0 35%" }} names={names} data={data} />
//       <PdfConnector path={path} style={{ flex: "0 0 35%" }} />
//       <RightPortion style={{ flex: "0 0 30%" }} />
//     </div>
//   );
// }

// export default App;

import { Resizable } from "re-resizable";
import "./css/App.css";
import LeftPortion from "./js/leftPortion/leftPortion";
import RightPortion from "./js/rightPortion/rightPortion";
import React, { useState } from 'react';
import PdfConnector from "./js/middlePortion/pdfConnector";
import LoginPage from './js/loginPage/loginPage';

import pdf from "./js/resources/Wirt.pdf";
import data from "./js/resources/Wirt-new.json";

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const appStyle = isAuthenticated ? {
    overflow: "hidden",
    height: "100vh",
  } : {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
  };

  return (
    <div className="flex flex-row" style={appStyle}>
      {isAuthenticated ? (
        <>
          <Resizable
            defaultSize={{
              width: "30%",
              height: "100vh",
            }}
            handleStyles={{
              right: {
                cursor: "col-resize",
                width: "7px",
                marginRight: "2px",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
              },
            }}
            minWidth="15%"
            maxWidth="100%"
            enable={{
              top: false,
              right: true,
              bottom: false,
              left: false,
              topRight: false,
              bottomRight: false,
              bottomLeft: false,
              topLeft: false,
            }}
          >
            <div style={{ overflowY: "auto", height: "100%" }}>
              <LeftPortion style={{ flex: "1" }} names={names} data={data} />
            </div>
          </Resizable>
          <Resizable
            defaultSize={{
              width: "45%",
              height: "100vh",
            }}
            handleStyles={{
              right: {
                cursor: "col-resize",
                width: "7px",
                marginRight: "2px",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
              },
            }}
            minWidth="35%"
            maxWidth="90%"
            enable={{
              top: false,
              right: true,
              bottom: false,
              left: false,
              topRight: false,
              bottomRight: false,
              bottomLeft: false,
              topLeft: false,
            }}
          >
            <PdfConnector data={pdf} style={{ flex: "1" }} />
          </Resizable>
          <RightPortion style={{ flex: "1" }} />
        </>
      ) : (
        <LoginPage onLogin={handleLogin} />
      )}
    </div>
  );
}

export default App;
